import { gql } from '@apollo/client';

export const FR_POINT_FIELDS = gql`
    fragment fr_PointFields on Point {
        PointId
        x
        y
        z
        State
        WGS84_lat
        WGS84_long
    }
`;

